// Helpers tipados del módulo de autenticación (login).
// Centraliza la llamada al backend para que Login/useLogin no repitan rutas/DTOs.
// Base de la API y token JWT los resuelve `api` (lib/api.ts).

import { api } from './api';

export interface Sesion {
  id: string;
  nombre: string;
  numeroDocumento: string;
  rol: string;
  area?: string;
}

export interface RespLogin {
  accessToken: string;
  usuario: Sesion;
}

export async function iniciarSesion(numeroDocumento: string, password: string): Promise<RespLogin> {
  return api<RespLogin>('/auth/login', {
    method: 'POST',
    auth: false,
    body: { numeroDocumento, password },
  });
}

/**
 * Auto-recuperación de contraseña (pública, desde el login): si el documento
 * corresponde a un usuario activo, el backend envía al correo registrado el
 * enlace de restablecimiento. La respuesta es siempre genérica.
 */
export async function solicitarRecuperacion(numeroDocumento: string): Promise<{ ok: true }> {
  return api<{ ok: true }>('/usuarios/recuperar-contrasena', {
    method: 'POST',
    auth: false,
    body: { numeroDocumento },
  });
}
